import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import JSONbig from 'json-bigint';
import {
  barbersLimitedReservationApiUrl,
  adminPassword,
  adminUsername,
} from '../../config';
import { CreateBookingSlot } from '../../types/bookingSlot';
import {
  serializeCreateSlotData,
  serializeReservationData,
} from './dataSerializer';
import { Booking } from '../../types/booking';

const response = [
  (data: any) => {
    if (typeof data === 'string') {
      try {
        data = JSONbig.parse(data);
      } catch (e) {
        console.error(e);
      }
    }
    return data;
  },
];

export const addShopSlot = async (
  slotData: CreateBookingSlot
): Promise<AxiosResponse> => {
  const serializedData = serializeCreateSlotData(slotData, {
    includeShopId: true,
  });

  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedReservationApiUrl}/shop-slots`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    data: serializedData,
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error adding shop slot:', error);
    throw error;
  }
};

export const addBarberSlot = async (
  slotData: CreateBookingSlot
): Promise<AxiosResponse> => {
  const serializedData = serializeCreateSlotData(slotData);

  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedReservationApiUrl}/barber-slots`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    data: serializedData,
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error adding barber slot:', error);
    throw error;
  }
};

export const createBooking = async (
  bookingData: Booking
): Promise<AxiosResponse> => {
  const serializedData = serializeReservationData(bookingData);

  const config: AxiosRequestConfig = {
    method: 'POST',
    url: `${barbersLimitedReservationApiUrl}/bookings`,
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    data: serializedData,
    transformResponse: response,
  };

  try {
    return await axios(config);
  } catch (error) {
    console.error('Error creating booking:', error);
    throw error;
  }
};
